import type { Location } from "history";
import type { FC } from "react";
import { useEffect } from "react";

import { GenericLoader, PageContent } from "@shared/components";
import { useLocation } from "@shared/react-router-dom";

const getPath = (location: Location) => {
  if (location.search) {
    return `${location.pathname}${location.search}`;
  }

  return location.pathname;
};

const ReloadPage: FC = () => {
  const location = useLocation();

  useEffect(() => {
    window.location.assign(getPath(location));
  }, []);

  return (
    <PageContent>
      <GenericLoader />
    </PageContent>
  );
};

export { ReloadPage };
